import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'business/constants';
import { RQAPICallWithData } from 'store/APIClient';

import type { DataCatalogField } from '../types';

export const useAPIGetDataCatalogFields = (
    enabled: boolean | undefined = true,
) =>
    useQuery({
        queryKey: ['data_catalog_fields'],

        queryFn: async () => {
            const response = await RQAPICallWithData<DataCatalogField[]>({
                endpoint: `data_catalog/fields`,
                method: 'GET',
            });
            return response.content.data;
        },

        staleTime: STALE_TIME,
        enabled,
    });
